import React, { Reducer, useReducer } from "react";
import { FeedCurve } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";
import { cloneDeep } from "lodash";
import constructDataMap from "./_FeedCurveViewer/constructDataMap";
import { colors, fonts } from "../../../Styles";
import { LabelsComponents, LabelsMilestones } from "./SubComponents";
import FeedCurveGraph from "./rawFeedCurveGraph";
import { FeedCurveContext, FeedCurveDispatcherT, FeedCurveReducer, GraphTypes, IFeedCurveContext } from "../../FeedCurves/_FeedCurves/feedCurveContext";
import { useTranslation } from "react-i18next";

interface FeedCurveMiniatureProps {
  data: FeedCurve;
  invertedColors?: boolean;
  showLabels?: boolean;
}

export default function FeedCurveMiniature({ data: feedCurve, invertedColors = false, showLabels = false }: FeedCurveMiniatureProps) {
  const { t } = useTranslation();
  const { dataMap, lastDay, firstDay, maxAmount, minAmount, milestonesFirstDay } = constructDataMap(cloneDeep(feedCurve));

  // Reducer
  const [_state, dispatch] = useReducer<Reducer<IFeedCurveContext, FeedCurveDispatcherT>>(FeedCurveReducer, {
    graphType: GraphTypes.feedCurveMiniature,
    milestone: {
      selectedMilestone: undefined,
      selectedDay: undefined
    },
    component: undefined,
    error: { Elementid: 0, errorText: "" },
  } as IFeedCurveContext);

  return (
    <FeedCurveContext.Provider value={{ state: _state, dispatch }}>
      <div style={{ width: "100%", height: "fit-content", boxSizing: "border-box", display: "flex", flexDirection: "column", gap: "20px", alignItems: "center", justifyContent: "center", position: "relative" }}>
          {feedCurve &&
            <FeedCurveGraph
              data={feedCurve}
              invertedColors={invertedColors}
              isMiniature
              dataMapConstruction={{
                dataMap: dataMap,
                firstDay: firstDay,
                lastDay: lastDay,
                maxAmount: maxAmount,
                milestonesFirstDay: milestonesFirstDay,
                minAmount: minAmount
              }}
            />
          }

        { showLabels ?
          <div style={{ display: "grid", width: "100%", gridTemplateColumns: "1fr 2px 1fr", gridTemplateRows: "1fr", gap: "10px" }}>
            <div style={{ gridArea: "1/1/2/2", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "Start", gap: "10px", }}>
              <p style={{ ...fonts.header, ...fonts.fontSize4, color: colors.greyDarkPrimary }}>{t("feedCurvePages.components.components", {defaultValue: "components"})}</p>
              <LabelsComponents feedCurve={feedCurve} />
            </div>
          
            <div style={{ gridArea: "1/2/2/3", width: "2px", height: "100%", borderRight: "2px solid " + colors.greyTertiary }} />

            <div style={{ gridArea: "1/3/2/4", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "Start", gap: "10px" }}>
              <p style={{ ...fonts.header, ...fonts.fontSize4, color: colors.greyDarkPrimary }}>{t("milestones.general.milestones", {defaultValue: "milestones"})}</p>
              <LabelsMilestones feedCurve={feedCurve} />
            </div>
          </div>
        : <></>}
      </div>
    </FeedCurveContext.Provider>
  );
}